import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function FAQSection() {
  const faqs = [{
    q: '¿Cuándo lo recibo?',
    a: 'Inmediatamente después del pago. Al ser un producto 100% digital, recibirás un correo con el acceso instantáneo para que puedas leerlo desde tu celular, tablet o computadora en cualquier momento.'
  }, {
    q: '¿Sirve si mi hijo tiene más de 1 año?',
    a: '¡Sí, absolutamente! El sistema cubre todas las etapas desde el nacimiento hasta los 3 años, con contenido específico, rutinas y actividades adaptadas para cada mes de desarrollo.'
  }, {
    q: '¿Necesito experiencia?',
    a: 'No, está diseñado especialmente para mamás primerizas o que se sienten perdidas. Te explicamos todo paso a paso, con un lenguaje simple y sin tecnicismos médicos.'
  }, {
    q: '¿Es práctico?',
    a: 'Es 100% práctico. No vas a encontrar relleno teórico. Incluye ejemplos reales, guías de acción rápida y 100 actividades listas para aplicar hoy mismo según la edad de tu bebé.'
  }, {
    q: '¿Voy a ver cambios rápido?',
    a: 'Sí. Al aplicar las rutinas y entender el porqué de los comportamientos, la mayoría de las mamás notan una reducción del estrés y berrinches en los primeros 7 a 14 días.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-cream py-24 px-6" data-id="element-81">
      <div className="max-w-3xl mx-auto" data-id="element-82">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-brand-black text-center mb-12" data-id="element-83">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-84">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl shadow-sm border border-brand-sage/10 overflow-hidden transition-all duration-300" data-id="element-85">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-86">
                <span className="font-bold text-brand-charcoal text-lg" data-id="element-87">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-sage transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-88" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-60 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-89">
                <p className="text-brand-charcoal/80 text-lg leading-relaxed" data-id="element-90">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-91">
          <CTAButton data-id="element-92" />
        </div>
      </div>
    </section>;
}